export const MAXIMUM_PRICE_CENTS = 9_223_372_036_854_775_807n

export function formatWholeBrl(value) {
  const digits = String(value || '').replace(/\D/g, '')
  if (!digits) return ''

  return BigInt(digits).toLocaleString('pt-BR')
}

export function wholeBrlToCents(value) {
  const digits = String(value || '').replace(/\D/g, '')
  if (!digits) return null

  const cents = BigInt(digits) * 100n
  if (cents <= 0n || cents > MAXIMUM_PRICE_CENTS) return null

  return cents.toString()
}

export function budgetGuidance({ priceCents, budgetCents, buyerName, budgetLabel, messages }) {
  const values = { BUYER: buyerName, BUDGET: budgetLabel }
  const message = (key) => interpolate(messages[key], values)

  if (!budgetCents) return { tone: 'muted', text: message('open') }
  if (!priceCents) return { tone: 'muted', text: message('empty') }
  if (BigInt(priceCents) <= BigInt(budgetCents)) return { tone: 'within', text: message('within') }

  return { tone: 'muted', text: message('above') }
}

function interpolate(template, values) {
  return Object.entries(values).reduce(
    (text, [key, value]) => text.replaceAll(`__${key}__`, value),
    template
  )
}
